import { FC } from 'react';
import { TbMoodHappy, TbMoodNeutral, TbMoodSad } from 'react-icons/tb';

import SearchFilterCheckboxList from '@/shared/components/filters/SearchFilterCheckboxList';

interface SentimentProps {
    filters: Record<string, unknown>;
    handleChange: (path: string[], value: unknown) => void;
}

const Sentiment: FC<SentimentProps> = ({ filters, handleChange }): JSX.Element => (
    <SearchFilterCheckboxList
        onChange={(value) => handleChange(['sentiments'], value)}
        options={[
            { icon: <TbMoodHappy />, label: 'Positive', value: 'Positive' },
            { icon: <TbMoodNeutral />, label: 'Neutral', value: 'Neutral' },
            { icon: <TbMoodSad />, label: 'Negative', value: 'Negative' },
        ]}
        value={Array.isArray(filters.sentiments) ? filters.sentiments.map(String) : []}
    />
);

export default Sentiment;
